import { ChangeDetectionStrategy, Component } from '@angular/core';
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-error',
  imports: [
    I18NextPipe
  ],
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ErrorComponent {}
